"use strict";

var widgetsSignInServiceRequestControllers = angular.module("controllers.service.widgets.signin", []);

widgetsSignInServiceRequestControllers.controller("wSignInTimeCtrl",
    ['$scope', 'lookUpService', '$routeParams', 'engineerService', 'serviceRequestSignIn', 'storeService', 'clockService', '$filter', 'localStorageService', 'storageKeys', '$translate', 'hazardAssessmentService',
        function ($scope, lookUpService, $routeParams, engineerService, serviceRequestSignIn, storeService, clockService, $filter, localStorageService, storageKeys, $translate, hazardAssessmentService) {

            $scope.appDateTimeFormat = localStorageService.get(storageKeys.appDateTimeFormat);
            $scope.appDateFormat = localStorageService.get(storageKeys.appDateFormat);

            $scope.widgetInfo = {
                step: 0,
                goBack: false,
                title: $translate.instant('label.controller.services.createWidgetsController.SignInTime')
            };

            $scope.error = false;

            // The maximum sign in time allowed is right now.
            clockService.getTime().then(function (response) {
                $scope.maxDate = response.storeTime;

                if (serviceRequestSignIn.get().signInTime != null) {
                    $scope.signInTime = serviceRequestSignIn.get().signInTime;
                } else {
                    $scope.signInTime = new Date(response.storeTime);
                }
            });

            serviceRequestSignIn.getMinSignInDate().then(function (value) {
                if (value !== null) {
                    $scope.minDate = value;
                }
            });

            $scope.engineers = [];
            $scope.showChangeEngineerButton = serviceRequestSignIn.getProperties().changeEngineer;

            $scope.showFastSignIn = serviceRequestSignIn.getProperties().fastSignIn;

            $scope.hazardAssessmentFastSignList = [];

            var serviceRequestResource = serviceRequestSignIn.get().serviceRequest;
            if (serviceRequestSignIn.get().engineer && serviceRequestSignIn.get().engineer !== null) {
                $scope.engineer = serviceRequestSignIn.get().engineer;
            } else {
                serviceRequestResource.$get("engineer").then(function (engineer) {
                    $scope.engineer = engineer;
                });
            }

            serviceRequestResource.$get("serviceProvider").then(function (serviceProvider) {
                engineerService.findByServiceProvider(serviceProvider.id).then(function (resource) {
                        resource.$get("engineerList").then(function (engineers) {
                            $scope.engineers = engineers;
                        });
                    },
                    function (status) {
                        if (status.status === 404) $scope.widgetInfo.step = 2;
                    });
            });

            $scope.$watch('widgetInfo.step', function (newValue, oldValue) {
                switch (newValue) {
                    case 0:
                        $scope.widgetInfo.title = $translate.instant('label.controller.services.signInWidgetsController.SignInTime');
                        $scope.widgetInfo.goBack = false;
                        break;
                    case 1:
                        $scope.widgetInfo.title = $translate.instant('label.controller.services.createWidgetsController.SelectEngineer');
                        $scope.widgetInfo.goBack = true;
                        break;
                    case 2:
                        $scope.widgetInfo.title = $translate.instant('label.controller.services.createWidgetsController.FastSignIn');
                        $scope.widgetInfo.goBack = true;
                        break;
                }
            });
            $scope.goBack = function () {
                $scope.widgetInfo.step = 0;
            };

            $scope.changeEngineer = function () {
                $scope.widgetInfo.step++;
            };

            $scope.fastSignInStep = function () {
                $scope.widgetInfo.step = 2;
            };

            $scope.storeMode = storeService.isStoreMode();

            $scope.selectEngineer = function (index) {
                $scope.engineer = $scope.engineers[index];
                $scope.widgetInfo.step--;
            };

            $scope.selectHazardAssessment = function (index) {
                if (index !== null) {
                    if ($scope.hazardAssessmentFastSignList[index].hazardGroupVisitId === null) {
                        serviceRequestSignIn.setFastSignInUsed(false);
                    } else {
                        serviceRequestSignIn.setHazardAssessmentFastSignIn($scope.hazardAssessmentFastSignList[index]);
                        serviceRequestSignIn.setFastSignInUsed(true);
                    }
                }
                $scope.$parent.next();
            };

            $scope.validationSignInTime = function (value) {
                // update the maxDate to the current time (if the minute has change since the page had been open)
                return clockService.getTime().then(function (response) {
                    $scope.maxDate = response.storeTime;
                    if (value == null || value == '') {
                        $scope.error = true;
                        $scope.timeErrorMessage = $translate.instant('label.controller.services.controller.EnterTime');
                    } else if (clockService.roundedUpDate(value) < $scope.minDate) {
                        $scope.error = true;
                        $scope.timeErrorMessage = $translate.instant('label.controller.services.controller.MinimumTime') + $filter('date')($scope.minDate, 'yyyy-MM-dd HH:mm')
                    } else if (clockService.getStringFromTime(clockService.roundedDownDate(value)) > $scope.maxDate) {
                        $scope.error = true;
                        $scope.timeErrorMessage = $translate.instant('label.controller.services.controller.MaximumTime') + $filter('date')($scope.maxDate, 'yyyy-MM-dd HH:mm');
                    } else {
                        $scope.error = false;
                    }
                });
            };

            $scope.updateSignInTime = function (value) {
                $scope.validationSignInTime(value);
                $scope.signInTime = value;
            };

            $scope.next = function () {
                $scope.validationSignInTime($scope.signInTime).then(function () {
                    if ($scope.error) {
                        return;
                    }

                    serviceRequestSignIn.setSignInTime($scope.signInTime);

                    if (!storeService.isStoreMode()) {
                        serviceRequestSignIn.setEngineer(localStorageService.get(storageKeys.profileKey).engineer);
                    } else {
                        serviceRequestSignIn.setEngineer($scope.engineer);
                    }

                    var fastSignInEnabled = serviceRequestSignIn.get().engineer.fastSignInEnabled;
                    var applicationFastSignInEnabled = serviceRequestSignIn.get().engineer.applicationFastSignInEnabled;

                    var storeDetails = $scope.store != undefined ? $scope.store : localStorageService.get(storageKeys.storeKey);

                    if (fastSignInEnabled && applicationFastSignInEnabled) {
                        hazardAssessmentService.findByStoreAndTime(storeDetails.id, $scope.engineer.id,
                            clockService.getStringFromTime(serviceRequestSignIn.get().signInTime), serviceRequestSignIn.get().serviceRequest.id)
                            .then(function (resource) {
                                    var blankHazardAssessmentFastSign = {"hazardGroupVisitId": null, "hazardNames": "New Risk Assessment", "signInTime": null}
                                    resource.$get("hazardAssessmentFastSignList").then(function (hazardAssessments) {
                                        $scope.hazardAssessmentFastSignList = hazardAssessments;
                                        $scope.hazardAssessmentFastSignList.unshift(blankHazardAssessmentFastSign);
                                        $scope.fastSignInStep();
                                    });
                                },
                                function (status) {
                                    if (status.status === 404) {
                                        serviceRequestSignIn.setFastSignInUsed(false);
                                        $scope.$parent.next();}
                                });
                    } else {
                        serviceRequestSignIn.setFastSignInUsed(false);
                        $scope.$parent.next();
                    }
                });
            };
        }]);

widgetsSignInServiceRequestControllers.controller("wPrerequisiteCtrl", ['$scope', 'lookUpService', 'serviceRequestSignIn', function ($scope, lookUpService, serviceRequestSignIn) {

    $scope.prerequisites = [];
    $scope.error = false;
    $scope.engineer = serviceRequestSignIn.get().engineer;
    $scope.contractorIdChecked = false;

    if (serviceRequestSignIn.get().fastSignInUsed) {
        for (var i = 0; i < $scope.prerequisites.length; i++) {
            $scope.prerequisites[i].selected = true;
        }

        $scope.contractorIdChecked = true;
        $scope.$parent.next(true);
    } else {
        lookUpService.list("static/json/prerequisites.json").then(function (resource) {
            $scope.prerequisites = resource;
        });

        $scope.completePrerequisites = function () {
            for (var i = 0; i < $scope.prerequisites.length; i++) {
                if (!$scope.prerequisites[i].selected) {
                    $scope.error = true;
                    return;
                }
            }

            if (!$scope.contractorIdChecked) {
                $scope.error = true;
                return;
            }

            if (serviceRequestSignIn.get().fastSignInUsed) {
                $scope.$parent.next();
            }
            $scope.$parent.next();
        };
    }
}]);

widgetsSignInServiceRequestControllers.controller("wRiskAssessmentCtrl", ['$scope', 'lookUpService', 'controlMeasureService', 'serviceRequestSignIn', '$translate', function ($scope, lookUpService, controlMeasureService, serviceRequestSignIn, $translate) {
    $scope.widgetInfo = {
        step: 0,
        goBack: false,
        title: $translate.instant('label.controller.services.createWidgetsController.PotentialRisk')
    };

    $scope.potentialHazards = [];
    $scope.selectedPotentialHazards = [];
    $scope.selectedPotentialHazardsIndex = -1;
    $scope.controlMeasures = [];
    $scope.hazardAssessments = [];

    if (serviceRequestSignIn.get().fastSignInUsed) {
        $scope.$parent.next(true);
    } else {
        lookUpService.list("potentialHazard").then(function (resource) {
            resource.$get("potentialHazardList").then(function (potentialHazards) {
                $scope.potentialHazards = potentialHazards;
            });
        });

        $scope.selectPotentialHazards = function () {
            for (var i = 0; i < $scope.potentialHazards.length; i++) {
                if ($scope.potentialHazards[i].selected) {
                    $scope.selectedPotentialHazards.push($scope.potentialHazards[i]);
                }
            }
            if ($scope.selectedPotentialHazards.length > 0) {
                for (var i = 0; i < $scope.selectedPotentialHazards.length; i++) {
                    $scope.hazardAssessments[i] = {};
                }
                $scope.selectedPotentialHazardsIndex++;
                $scope.widgetInfo.step++;


                if (!serviceRequestSignIn.getProperties().showSiteSpecificHazards) {
                    $scope.showHazardRating();
                }
            } else {
                $scope.$parent.next();
            }
        };

        $scope.nextHazard = function () {
            if ($scope.selectedPotentialHazards[$scope.selectedPotentialHazardsIndex].beforeRating == 0
                || $scope.selectedPotentialHazards[$scope.selectedPotentialHazardsIndex].afterRating == 0) {
                return;
            }

            //if($scope.selectedPotentialHazards[$scope.selectedPotentialHazardsIndex + 1] != null){
            if (($scope.selectedPotentialHazardsIndex + 1) < $scope.selectedPotentialHazards.length) {
                $scope.selectedPotentialHazardsIndex++;
                $scope.widgetInfo.step = 1;
            } else {
                completeRiskAssessment();
            }
        };

        $scope.showHazardRating = function () {
            var selectedControlMeasures = [];
            for (var i = 0; i < $scope.controlMeasures.length; i++) {
                if ($scope.controlMeasures[i].selected) {
                    selectedControlMeasures.push($scope.controlMeasures[i]);
                }
            }

            $scope.selectedPotentialHazards[$scope.selectedPotentialHazardsIndex].controlMeasures = selectedControlMeasures;
            $scope.selectedPotentialHazards[$scope.selectedPotentialHazardsIndex].hazardRatingBefore = 0;
            $scope.selectedPotentialHazards[$scope.selectedPotentialHazardsIndex].hazardRatingPast = 0;
            $scope.hazardAssessments[$scope.selectedPotentialHazardsIndex].controlMeasures = {};
            $scope.hazardAssessments[$scope.selectedPotentialHazardsIndex].controlMeasures = selectedControlMeasures;
            $scope.hazardAssessments[$scope.selectedPotentialHazardsIndex].potentialHazard = {};
            $scope.hazardAssessments[$scope.selectedPotentialHazardsIndex].potentialHazard = $scope.selectedPotentialHazards[$scope.selectedPotentialHazardsIndex];
            $scope.widgetInfo.step++;

            if (!serviceRequestSignIn.getProperties().showHazardRating) {
                $scope.nextHazard();
            }
        };

        $scope.$watch('selectedPotentialHazardsIndex', function (newValue, oldValue) {
            if ($scope.selectedPotentialHazardsIndex > -1) {
                controlMeasureService.findByPotentialHazard($scope.selectedPotentialHazards[$scope.selectedPotentialHazardsIndex].id).then(function (resource) {
                    resource.$get("controlMeasureList").then(function (controlMeasures) {
                        $scope.controlMeasures = controlMeasures;
                    });
                });
            }
        });

        $scope.$watch('widgetInfo.step', function (newValue, oldValue) {
            switch (newValue) {
                case 0:
                    $scope.widgetInfo.title = $translate.instant('label.controller.services.createWidgetsController.PotentialRisk');
                    $scope.widgetInfo.goBack = false;
                    break;
                case 1:
                    $scope.widgetInfo.title = $translate.instant('label.controller.services.createWidgetsController.ControlMeasures');
                    $scope.widgetInfo.goBack = true;
                    break;
                case 2:
                    $scope.widgetInfo.title = $translate.instant('label.controller.services.createWidgetsController.HazardRating');
                    $scope.widgetInfo.goBack = true;
                    break;
            }
        });
    }

    function completeRiskAssessment() {
        serviceRequestSignIn.setHazardAssessments($scope.hazardAssessments);
        $scope.$parent.next();
    }
}]);

widgetsSignInServiceRequestControllers.controller("wWorkAuthorisationCtrl", ['$scope', 'lookUpService', '$translate', function ($scope, lookUpService, $translate) {

    $scope.workAuthorisations = [];
    $scope.error = false;

    lookUpService.list("static/json/authorisation.json").then(function (resource) {

        $scope.workAuthorisations = resource;

        for (var i = 0; i < resource.length; i++) {

            $scope.workAuthorisations[i].translatedName = $translate.instant(resource[i].name);
            $scope.workAuthorisations[i].translatedDescription = $translate.instant(resource[i].content.description);

            var translatedLabels = [];

            for (var j = 0; j < resource[i].content.list.length; j++) {
                var label = resource[i].content.list[j];
                var translated = $translate.instant(label);

                // some environments may have less translations set for labels in authorisation.json
                if (translated != label) {
                    translatedLabels.push(translated);
                }
            }

            $scope.workAuthorisations[i].translatedLabels = translatedLabels;
        }
    });

    $scope.completeWorkAuthorisations = function () {
        for (var i = 0; i < $scope.workAuthorisations.length; i++) {
            if (!$scope.workAuthorisations[i].selected) {
                $scope.error = true;
                return;
            }
        }

        $scope.$parent.next();
    };
}]);

widgetsSignInServiceRequestControllers.controller("wSignInEngineerSignatureCtrl", ['$scope', 'serviceRequestSignIn',
    function ($scope, serviceRequestSignIn) {

        $scope.continue = function (value) {
            serviceRequestSignIn.setEngineerSignature(value);
            serviceRequestSignIn.setCheckListCompleted(true);
            $scope.$parent.next();
        };
    }]);

widgetsSignInServiceRequestControllers.controller("wSignInManagerSignatureCtrl", ['$scope', 'serviceRequestSignIn',
    function ($scope, serviceRequestSignIn) {

        $scope.continue = function (value) {
            serviceRequestSignIn.setManagerSignature(value);
            $scope.$parent.next();
        };
    }]);

widgetsSignInServiceRequestControllers.controller("wSignInAuthenticateManagerCtrl", ['$scope', 'serviceRequestSignIn',
    function ($scope, serviceRequestSignIn) {
        $scope.manager = serviceRequestSignIn.get().manager;
    }]);

widgetsSignInServiceRequestControllers.controller("wSignInAuthenticateEngineerCtrl", ['$scope', 'serviceRequestSignIn',
    function ($scope, serviceRequestSignIn) {
        $scope.engineer = serviceRequestSignIn.get().engineer;
        serviceRequestSignIn.get().engineer.$get("user").then(function (user) {
            $scope.engineer = user;
        });
    }]);

widgetsSignInServiceRequestControllers.controller("wSignInManagerSelectCtrl", ['$scope', 'serviceRequestSignIn',
    function ($scope, serviceRequestSignIn) {

        $scope.processUser = function (user) {
            serviceRequestSignIn.setSignedInBy(user.username);
        }
    }]);

widgetsSignInServiceRequestControllers.controller("wSignInAuthoriseManagerSelectCtrl", ['$scope', 'serviceRequestSignIn',
    function ($scope, serviceRequestSignIn) {

        $scope.processUser = function (user) {
            if (serviceRequestSignIn.get().signedInBy == null) {
                serviceRequestSignIn.setSignedInBy(user.username);
            }
            serviceRequestSignIn.setApprover(user.username);
        }
    }]);

widgetsSignInServiceRequestControllers.controller("wSignInFinishCtrl", ['$scope', '$location', 'serviceRequestService', 'serviceRequestSignIn', 'storeService', 'clockService', 'localStorageService', 'storageKeys',
    function ($scope, $location, serviceRequestService, serviceRequestSignIn, storeService, clockService, localStorageService, storageKeys) {

        $scope.appDateTimeFormat = localStorageService.get(storageKeys.appDateTimeFormat);
        $scope.appDateFormat = localStorageService.get(storageKeys.appDateFormat);

        $scope.success = 0;
        $scope.review = {};
        $scope.saveResult = {};
        $scope.review.engineer = serviceRequestSignIn.get().engineer;
        $scope.review.signInTime = serviceRequestSignIn.get().signInTime;

        $scope.signIn = function () {
            var serviceRequests = [serviceRequestSignIn.get().serviceRequest.id];
            var combineRequests = serviceRequestSignIn.get().combineRequests;
            if (null != combineRequests) {
                for (var i = 0; i < combineRequests.length; i++) {
                    serviceRequests.push(combineRequests[i]);
                }
            }
            for (var i = 0; i < serviceRequests.length; i++) {

                var visitToSave = {
                    serviceRequestId: serviceRequests[i],
                    approver: serviceRequestSignIn.get().approver,
                    serviceActionType: serviceRequestSignIn.get().serviceActionType,
                    hazardAssessments: serviceRequestSignIn.get().hazardAssessments,
                    signInTime: clockService.getStringFromTime(serviceRequestSignIn.get().signInTime),
                    engineer: serviceRequestSignIn.get().engineer,
                    fastSignInUsed: serviceRequestSignIn.get().fastSignInUsed,
                    hazardAssessmentFastSignIn: serviceRequestSignIn.get().hazardAssessmentFastSignIn,
                    checklist: {
                        managerSignature: serviceRequestSignIn.get().managerSignature,
                        engineerSignature: serviceRequestSignIn.get().engineerSignature,
                        checkListCompleted: serviceRequestSignIn.get().checkListCompleted,
                        signedInBy: serviceRequestSignIn.get().signedInBy
                    }
                };

                serviceRequestService.signin(visitToSave).then(
                    function (response) {
                        $scope.saveResult = response;
                        $scope.success = 1;
                        $scope.$parent.finish();
                    },
                    function (status) {
                        if (status.status !== 200) {
                            // Something went wrong
                            $scope.success = -1;
                        }
                    }
                );
            }
        }


        $scope.goBack = function () {
            $location.path("/");
        }
    }]);

widgetsSignInServiceRequestControllers.controller("wSignInStoreWithSampleSignatureCtrl",
    ['$scope', 'serviceRequestService', 'serviceRequestSignIn', function ($scope, serviceRequestService, serviceRequestSignIn) {

        $scope.sample = false;

        $scope.continue = function (value) {
            serviceRequestSignIn.setManagerSignature(value);
            $scope.$parent.next();
        };
    }]);

widgetsSignInServiceRequestControllers.controller("wSignInCombineServiceRequestCtrl",
    ['$scope', 'serviceRequestService', 'serviceRequestSignIn', function ($scope, serviceRequestService, serviceRequestSignIn) {

        var serviceRequest = serviceRequestSignIn.get().serviceRequest;
        $scope.serviceRequests = [];
        $scope.selectedServiceRequests = [];

        serviceRequestService.combinedRequests(serviceRequest.id).then(function (resource) {
            resource.$get("serviceRequestList").then(function (serviceRequests) {
                $scope.serviceRequests = serviceRequests;

                for (var i = 0; i < serviceRequests.length; i++) {
                    if (serviceRequests[i].id === serviceRequest.id) {
                        serviceRequests.splice(i, 1);
                    }
                }
                if ($scope.serviceRequests.length < 1) $scope.$parent.next();

                $scope.serviceRequests.forEach(function (serviceRequest) {
                    // fetching ServiceEvent
                    serviceRequest.$get("serviceEvent").then(function (event) {
                        // fetching Machine
                        event.$get("machine").then(function (machine) {
                            // Adding machine to the model
                            serviceRequest.machine = machine;
                        });
                    });
                    serviceRequest.$get("engineer").then(function (engineer) {
                        // Adding engineer to the model
                        serviceRequest.engineer = engineer;
                    });
                });
            });
        });

        $scope.addServiceRequest = function (index) {
            var serviceRequest = $scope.serviceRequests[index]
            if ($scope.selectedServiceRequests.indexOf(serviceRequest) < 0) $scope.selectedServiceRequests.unshift(serviceRequest);
        }

        $scope.removeServiceRequest = function (index) {
            $scope.selectedServiceRequests.splice(index, 1);
        }

        $scope.next = function () {
            var combinedServiceRequests = [];
            for (var i = 0; i < $scope.selectedServiceRequests.length; i++) {
                if (serviceRequest.id != $scope.selectedServiceRequests[i].id) combinedServiceRequests.push($scope.selectedServiceRequests[i].id);
            }

            serviceRequestSignIn.setCombinedRequests(combinedServiceRequests);
            $scope.$parent.next();
        }
    }]);
